

import { io } from "socket.io-client";

// Use same base URL as API calls — supports ngrok/production without code change.
// Strip trailing /api if present to get the socket server root.
const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api";
const SOCKET_URL = API_BASE.replace(/\/api\/?$/, "");

// Token is read lazily at connect time (via auth callback) so it is always
// up-to-date even if the user logs in after this module was first imported.
export const socket = io(SOCKET_URL, {
    autoConnect: false,
    // Prefer WebSocket first — avoids slow HTTP polling via ngrok/proxies
    transports: ["websocket", "polling"],
    auth: (cb) => {
        cb({ token: localStorage.getItem("authToken") });
    },
});